import { WIRTransverseRoles, WIRUser } from 'types/wellGuardian';

export const getUsersList = (users: WIRUser[], role: WIRTransverseRoles) =>
  users
    .filter(
      item => item.roles?.includes(role) && !item.roles?.includes(WIRTransverseRoles.WIR_DEVELOPER),
    )
    .sort((itemA, itemB) => `${itemA.userName}`.localeCompare(`${itemB.userName}}`));
